import styled, { css } from 'styled-components';
import { Box } from '@sparknz/spark-pattern-library';

const Tag = styled(Box)`
  ${({ theme: { borderRadius, palette } }) => css`
    background: ${palette.baseColors.newZealandBlack};
    align-self: flex-end;
    border-top-left-radius: ${borderRadius.rHalf};
    border-bottom-left-radius: ${borderRadius.rHalf};
  `}
`;

export default Tag;
